/**
 * @generated SignedSource<<2f180b5d7fea1700b0947571b641716a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddOrRemoveAssignmentPrintTypeToProductsInput = {
  modelSidesToAssignsDto?: ReadonlyArray<AddOrRemoveAssignmentPrintTypeToProductsModelSidesToAssignInput | null> | null;
  printTypeID: string;
  productIDsToRemove?: ReadonlyArray<string | null> | null;
};
export type AddOrRemoveAssignmentPrintTypeToProductsModelSidesToAssignInput = {
  modelID: string;
  sides: ReadonlyArray<PrintTypeModelSideInput | null>;
};
export type PrintTypeModelSideInput = {
  colorID: string;
  sideID: string;
};
export type productSidePanelContent_AssignPrintMethodMutation$variables = {
  input: AddOrRemoveAssignmentPrintTypeToProductsInput;
};
export type productSidePanelContent_AssignPrintMethodMutation$data = {
  readonly addOrRemoveAssignmentPrintTypeToProducts: boolean;
};
export type productSidePanelContent_AssignPrintMethodMutation = {
  response: productSidePanelContent_AssignPrintMethodMutation$data;
  variables: productSidePanelContent_AssignPrintMethodMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "addOrRemoveAssignmentPrintTypeToProducts",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_AssignPrintMethodMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "productSidePanelContent_AssignPrintMethodMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e41d7fd27c6a5f81ac199ac60b93ad23",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_AssignPrintMethodMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_AssignPrintMethodMutation(\n  $input: AddOrRemoveAssignmentPrintTypeToProductsInput!\n) {\n  addOrRemoveAssignmentPrintTypeToProducts(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "44f7154181e68636ae9f440a2d0d2d7e";

export default node;
